import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Crosshair } from 'lucide-react';
import { missions } from '../data/mock';
import SectionTitle from './SectionTitle';
import { Gear } from './animations/Gear';

export default function Missions() {
  const [active, setActive] = useState(0);
  const m = missions[active];

  return (
    <section id="missions" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-40" />
      <div className="absolute -left-32 -bottom-32 text-cyan-400/[0.04]">
        <div className="spin-slow"><Gear size={420} teeth={22} /></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionTitle code="SECTION / 04" title="MİSYON KABİLİYETLERİ" subtitle="Stratejik görevlerden özel operasyonlara, geniş spektrumlu kabiliyet seti." />

        <div className="mt-16 grid lg:grid-cols-12 gap-8">
          {/* Left list */}
          <div className="lg:col-span-5">
            <ul className="divide-y divide-cyan-500/10 border-y border-cyan-500/10">
              {missions.map((mission, i) => (
                <li key={mission.id}>
                  <button
                    onClick={() => setActive(i)}
                    className={`w-full text-left flex items-start gap-4 py-5 group transition-colors ${
                      active === i ? 'bg-cyan-400/[0.04]' : 'hover:bg-cyan-400/[0.02]'
                    }`}
                  >
                    <span className={`font-mono text-[10px] mt-1 transition-colors ${
                      active === i ? 'text-cyan-300' : 'text-cyan-400/40'
                    }`}>{mission.id}</span>
                    <div className="flex-1">
                      <div className="flex items-center gap-3">
                        <h3 className={`font-display text-lg font-bold transition-colors ${
                          active === i ? 'text-cyan-300' : 'text-slate-300 group-hover:text-white'
                        }`}>{mission.name}</h3>
                        {active === i && <span className="w-1.5 h-1.5 bg-cyan-400 blink" />}
                      </div>
                      <div className="text-[10px] font-mono tracking-[0.2em] text-slate-500 mt-1">{mission.short}</div>
                    </div>
                    <div className={`w-px self-stretch transition-colors ${active === i ? 'bg-cyan-400' : 'bg-transparent'}`} />
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Right detail panel - sonar style */}
          <div className="lg:col-span-7">
            <motion.div
              key={active}
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              className="relative aspect-square md:aspect-[5/4] border border-cyan-500/20 bg-[#070b12] overflow-hidden"
            >
              <span className="corner-mark corner-tl" />
              <span className="corner-mark corner-tr" />
              <span className="corner-mark corner-bl" />
              <span className="corner-mark corner-br" />

              {/* Sonar */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative w-[80%] aspect-square">
                  {[1, 2, 3, 4].map((r) => (
                    <div
                      key={r}
                      className="absolute inset-0 m-auto rounded-full border border-cyan-400/15"
                      style={{ width: `${r * 25}%`, height: `${r * 25}%` }}
                    />
                  ))}
                  {/* Pulse */}
                  <div className="absolute inset-0 m-auto w-[20%] h-[20%] rounded-full border-2 border-cyan-400 pulse-ring" />
                  <div className="absolute inset-0 m-auto w-[8%] h-[8%] rounded-full bg-cyan-400 glow-cyan" />
                  {/* Crosshair */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 h-full w-px bg-cyan-400/15" />
                  <div className="absolute left-0 top-1/2 -translate-y-1/2 w-full h-px bg-cyan-400/15" />
                  {/* Target dots */}
                  <Crosshair className="absolute top-[20%] left-[25%] w-5 h-5 text-cyan-300/70" />
                  <Crosshair className="absolute top-[60%] right-[20%] w-4 h-4 text-cyan-300/40" />
                  <Crosshair className="absolute bottom-[15%] left-[40%] w-3 h-3 text-cyan-300/50" />
                </div>
              </div>

              {/* Overlay info */}
              <div className="absolute top-4 left-4 right-4 flex items-start justify-between">
                <div>
                  <div className="text-[10px] font-mono tracking-[0.25em] text-cyan-400/60">MİSSİON / {m.id}</div>
                  <div className="font-display text-2xl md:text-3xl font-bold text-white mt-1">{m.name}</div>
                </div>
                <div className="text-right">
                  <div className="text-[10px] font-mono text-cyan-300">STATUS</div>
                  <div className="text-[10px] font-mono text-emerald-400 flex items-center gap-1.5 justify-end mt-1">
                    <span className="w-1.5 h-1.5 bg-emerald-400 blink" /> READY
                  </div>
                </div>
              </div>
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-sm text-slate-300 leading-relaxed max-w-xl">{m.desc}</p>
                <div className="mt-3 flex items-center gap-4 text-[10px] font-mono text-cyan-400/50">
                  <span>RANGE: 12.000 NM</span>
                  <span>DEPTH: 0—400 M</span>
                  <span>DURATİON: 90 D</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
